import React from 'react'
import Back from '../common/Back'
import ContactCard from './ContactCard'
import img from '../images/pricing.jpeg'
import '../contact/contact.css'
// import { Link } from 'react-router-dom'
// import { socials } from '../data/Data'

function Contact() {
  return (
    <>
      <section className='contact'>
      <Back name='Call, whatsapp or slide into our DMs' title='Stay In Touch' cover={img} />
       
      <div className='container flex mtop'>
        <div className='left row'>
          <ContactCard/>
        </div>
        <div className='right row'>
          <h4>Send us a message</h4>
          <p>Do you you have any questions related to prices or deco styles you can send me message from here. It's my pleasure to help you.</p>
          <h4>Follow us on social media</h4>
          <p>Stay up to date with our styles and never miss on any of our specials </p>
        
          <div class="socials">
            <a href="/contact"><i class="fab fa-facebook-f"></i></a>
            <a href="https://www.instagram.com/metadecorevents/"><i class="fab fa-instagram"></i></a>
            <a href="/https://www.tiktok.com/@metadecorevents"><i class="fab fa-tiktok"></i></a>
            <a href="https://wa.me/c/27646122609"><i class="fab fa-whatsapp"></i></a>
          </div>

        </div>
      </div> 
      </section>
    </>
  )
}

export default Contact